import CoreNavigationHeader from './CoreNavigationHeader';

export { type CoreNavigationHeaderProps } from './CoreNavigationHeader';
export default CoreNavigationHeader;
